import api from "./api.ts";
import type { AxiosResponse } from "axios";
import type { CourseType, Goal } from "../interfaces/goal.interface.ts";

export async function createGoal(classroomId: number, name: string, sectionId: number, courseType: CourseType): Promise<Goal> {
	const response: AxiosResponse<Goal> = await api.post("goal/create", {
		classroomId,
		name,
		sectionId,
		courseType
	});
	return response.data;
}

export async function removeGoal(goalId: number): Promise<boolean> {
	const response: AxiosResponse<boolean> = await api.delete(`goal/${goalId}`);
	return response.data;
}

export async function getGoals(classroomId: number): Promise<Goal[]> {
	const response: AxiosResponse<Goal[]> = await api.get(`goal/${classroomId}`);
	return response.data;
}
